import { render, staticRenderFns } from "./EditExerciseTextAudio.vue?vue&type=template&id=18696620&"
import script from "./EditExerciseTextAudio.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseTextAudio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports